<div class="flex flex-column gap-3">

    <!-- Entête : catégorie et date de publication (le header natif est désactivé) -->
    <div class="flex align-items-center justify-content-between gap-2 pt-3">
        <div class="flex align-items-center gap-2 flex-wrap">
            <p-tag [severity]="announcement.categorySeverity" [value]="announcement.categoryLabel"
                [rounded]="true"></p-tag>
            <span class="text-sm text-color-secondary">
                Publiée le {{ announcement.publishedAt.toDate() | date:'dd/MM/yyyy' }}
            </span>
        </div>

        <!-- Fermeture : absente quand l'annonce exige un acquittement -->
        @if (!announcement.requiresAcknowledgement) {
        <p-button icon="pi pi-times" severity="secondary" [rounded]="true" [text]="true"
            (onClick)="onClickClose()"></p-button>
        }
    </div>

    <!-- Titre, à la couleur de la catégorie -->
    <h1 class="m-0 pl-2" [ngClass]="announcement.categoryTextClass">{{ announcement.title }}</h1>

    <!-- Contenu Markdown -->
    <div class="surface-50 border-round p-4 overflow-y-auto" style="max-height: 50vh">
        <markdown class="markdown-content block" [data]="announcement.content"></markdown>
    </div>

    <!-- Acquittement -->
    <div class="flex justify-content-end">
        <p-button [label]="acknowledgeLabel" icon="pi pi-check"
            [severity]="announcement.requiresAcknowledgement ? 'primary' : 'secondary'"
            [raised]="announcement.requiresAcknowledgement" [outlined]="!announcement.requiresAcknowledgement"
            [rounded]="true" [loading]="acknowledging" (onClick)="onClickAcknowledge()"></p-button>
    </div>
</div>
